import {useQuery} from "@tanstack/react-query";
import {eventsEventIdApproversGet} from "../api/events/eventsEventIdApproversGet.ts";

export const useEventApprovers = (eventId: string) => useQuery({
    queryKey: ['event', 'approvers', eventId],
    queryFn: () => eventsEventIdApproversGet(eventId).then(r => r.payload),
})